import { Button, ButtonProps, TrashOutline } from '@bonusly/design-system';

export const DeleteIconButton = ({ ...rest }: ButtonProps) => {
	return (
		<Button colorScheme="secondary" backgroundColor="secondary.bgAlpha" variant="ghost" borderRadius="full" p={1.5} {...rest}>
			<TrashOutline size="sm" />
		</Button>
	);
};
